import React from 'react'
import Statics from '../Main/Statics'

function AboutStatic() {
    return (
        <>
            <div className="site-bg-primary aon-statics-area">
                <div className="container">
                    <div className="section-content">
                        <div className="row d-flex flex-wrap align-items-center a-b-none">
                            <div className="col-lg-6 col-md-12">
                                {/*Title Section Start*/}
                                <div className="section-head">
                                    <span className="aon-sub-title">Statics</span>
                                    <h2 className="sf-title text-white">
                                        Trusted by thousands of people all over the world
                                    </h2>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                        do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                        Quis ipsum suspendisse ultrices gravida.{" "}
                                    </p>
                                </div>
                                {/*Title Section End*/}
                            </div>
                            <div className="col-lg-6 col-md-12">
                                {/*Statics-blocks Section Start*/}
                                <Statics />
                                {/*Statics-blocks Section End*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutStatic
